import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initial: 'L',
  color: 'bg-emerald-100 text-emerald-700',
  name: 'Lic. Laura M.',
  location: 'Nutricionista — Buenos Aires',
  text: 'Solía tardar días en armar las pautas para pacientes con SIBO. Ahora descargo el protocolo, lo personalizo con mi logo y lo envío en el momento. Los pacientes quedan impresionados con la prolijidad del material.'
}, {
  initial: 'M',
  color: 'bg-blue-100 text-blue-700',
  name: 'Lic. Martín S.',
  location: 'Nutricionista Clínico — Córdoba',
  text: 'El módulo de comunicación simple me cambió la forma de explicar la resistencia a la insulina. Mis pacientes ahora entienden desde la primera consulta y los mensajes de soporte bajaron un 80%.'
}, {
  initial: 'V',
  color: 'bg-purple-100 text-purple-700',
  name: 'Dra. Valeria G.',
  location: 'Médica Funcional — Rosario',
  text: 'Mis pacientes con SOP me dicen que nunca habían recibido un material tan completo y tan claro. La guía hormonal es un antes y un después en mi consultorio.'
}, {
  initial: 'C',
  color: 'bg-amber-100 text-amber-700',
  name: 'Lic. Carolina P.',
  location: 'Nutricionista — Mendoza',
  text: 'El banco de checklists y el planificador de seguimiento me ahorran al menos dos horas por semana. Material excelente, diseño impecable y base científica sólida.'
}];
export function TestimonialsBottom() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-172">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-173">
        <div className="text-center mb-10" data-id="element-174">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-slate-900" data-id="element-175">
            Profesionales que ya transformaron su consulta
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-176">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full relative" data-id="element-177">
              <Quote className="absolute top-6 right-8 w-12 h-12 text-slate-100" data-id="element-178" />
              <div className="flex text-yellow-400 mb-6 relative z-10" data-id="element-179">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-180" />)}
              </div>

              <p className="text-slate-700 text-lg leading-relaxed mb-8 italic flex-grow relative z-10" data-id="element-181">
                "{t.text}"
              </p>

              <div className="flex items-center border-t border-slate-100 pt-6 mt-auto" data-id="element-182">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color} mr-4 flex-shrink-0`} data-id="element-183">
                  {t.initial}
                </div>
                <div data-id="element-184">
                  <div className="font-bold text-slate-900" data-id="element-185">{t.name}</div>
                  <div className="text-sm text-slate-500" data-id="element-186">{t.location}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}